import React, { useCallback, useEffect, useState } from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import "../../css/entry.css";
import { useLocation, useNavigate } from "react-router-dom";
import apiClient from "../../BaseUrl/apiClient.js";
import TokenService from "../../service/TokenService";
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import dayjs from "dayjs";
import SriyanshCardHeader from "../../components/CardHeader";
import { BoxStyle } from "../../constantVaribles/constatanvariable";
import EncryptService from "../../service/EncryptionService";
import ListHeaderTableComponent from "../../CustomComponant/ListHeaderTables";
import CustomTextField from "../../CustomComponant/CustomTextField ";
import DatePickerComponent from "../../CustomComponant/DateTimePickerField";
import NumericTextField from "../../CustomComponant/NeumericTextField";
import CustomDropdownMenu from "../../CustomComponant/DropDownMenu";
import TablewithSumFooter from "../../CustomComponant/TablewithSumFooter";
import { Accordion, AccordionDetails, AccordionSummary, Typography } from "@mui/material";
import { set } from "lodash";

import CircularProgress from "@mui/material/CircularProgress";
//import { useAuthentication } from "../../customHook/useAuthentecation";

function ItemReceivedEntry() {
  const navigate = useNavigate();
  const today = dayjs();
  const [unsuitablePOList, setunsuitablePOList] = useState([]);
  const [npoNumber, setpoNumber] = useState("");
  const [poItemName, setpoItemName] = useState("");
  const [poValue, setpoValue] = useState(0);
  const [poQuantity, setpoQuantity] = useState(0);
  const [suitabilityDone,setSuitabilityDone]=useState(null);
  const [poDate, setpoDate] = useState(Date);
  const [dpDate, setDPDate] = useState(Date);
  const [ConsigneeName, setConsigneeName] = useState("");
  const { state } = useLocation();
  let indentId = state.indent_id;

  const [itemreceivedDate, setitemreceivedDate] = useState(null);
  const [buttonLoading, setButtonLoading] = useState(false);
  const maxDate =
    dpDate && dayjs(dpDate).isBefore(today) ? dayjs(dpDate) : today;

  const [error, setError] = useState("");
  const [reason, setreason] = useState("");
  
  const [GeMNumber, setGeMNumber] = useState("");
  const [GemDate, setGemDate] = useState("");


  const [receivedQuantity, setreceivedQuantity] = useState();
  const [receivedValue, setreceivedValue] = useState();

  const [totBalanceqty, settotBalanceqty] = useState(0);
  const [totBalanceVal, settotBalanceVal] = useState(0);

  const [minCalDate, setMinCalDate] = useState(dayjs());

  const tokenServiceDetails = TokenService.getUserDetails();
  const uname = tokenServiceDetails?.uname;
  const ip = EncryptService.decrypt(sessionStorage.getItem("token1"));
  const [errors, setErrors] = useState({});

  const [selectedOption, setSelectedOption] = useState("");

  const [itemselectedOption, setitemselectedOption] = useState("");

  const [getpass, setgetpass] = useState("");

  const [showRemark, setShowRemark] = useState(true);

////// canclelation  tools
const [showcancleRemark, setShowcancleRemark] = useState(false);
const [cancleRemark, setcancleRemark] = useState("");

 const [pageLoader, setPageLoader] = useState(false);


  const [POReturnData, setPOReturnData] = useState([]);

  const [poindentnumber, setpoindentnumber] = useState("");

  const [tpiagency, settpiAgency] = useState("");
  const [tpiDate, setTpiDate] = useState(null);

  const [totalreceivedQuantity, settotalreceivedQuantity] = useState(0);
  const [totalreceivedValue, settotalreceivedValue] = useState(0);

  const handleButtonClick = (row) => {
  
  // console.log(row.getpassnumber);
  try {
      const response1 = apiClient.post("/suitabilityUpdate", {
        vponumber: String(indentId),
        vgetpassnumber: row?.getpassnumber,
        ventryuser: uname,
        vip: ip,
      });
      alert(response1?"Data Transfered to  Next Step" : "Check Data");
      handleClose();
    } catch (error) {
      setError(error.response1 ? error.response1.data : error.message);
    }
  };

  const handleOptionitemChange = (event) => {
    setitemselectedOption(event.target.value);
    setErrors({ selerr: "" });
  };

  const handleOptionChange = (event) => {
    const selvalue = event.target.value;
    setSelectedOption(event.target.value);
    if (selvalue === "0") {
      setShowRemark(true);
      // setReason("");
    } else {
      setShowRemark(false);
    }
    setErrors({ selerr: "" });
  };

  const handleQuantityChange = (value) => {
    setreceivedQuantity(value);
    // Update errors as needed; example here:
    setErrors({
      qty:
        value && !/^(\d+(\.\d+)?)?$/.test(value)
          ? "Invalid quantity format"
          : "",
    });
  };

  // const handleDateChange = (date) => {
  //   // Perform validation
  //   if (!date) {
  //     setError('Date is required.');
  //   } else if (dayjs(date).isBefore(minCalDate)) {
  //     setError(`Date cannot be earlier than ${minCalDate.format('YYYY-MM-DD')}`);
  //   } else if (dayjs(date).isAfter(today)) {
  //     setError(`Date cannot be later than ${today.format('YYYY-MM-DD')}`);
  //   } else {
  //     setError(''); // Clear error if validation passes
  //   }

  //   // Update state only if date is valid
  //   if (!error) {
  //     setitemreceivedDate(dayjs(date));
  //   }
  // };

  const handleValueChange = (value) => {
    setreceivedValue(value);
    // Update errors as needed; example here:
    setErrors({
      val:
        value && !/^(\d+(\.\d+)?)?$/.test(value)
          ? "Invalid quantity format"
          : "",
    });
  };

  const handleClose = () => {
    navigate("../itemreceivedlist", { replace: true });
  };

  const InsertPOData = async (e) => {
    e.preventDefault();
    setButtonLoading(true);
    let formErrors = {};

    //if (dateerror) formErrors.errDate = "Invalid Item Receipt Date";
    //if (tpidateerror) formErrors.errtpiDate = "Invalid TPI Date";

    
    if (!itemreceivedDate)
      {
        formErrors.errDate = "Invalid Item Receipt Date";
       
      } 


      if (!showRemark && !tpiDate)
        {
          formErrors.errtpiDate = "Invalid TPI Date";
         
        } 
  




    if (
      !receivedQuantity ||
      isNaN(parseFloat(receivedQuantity)) ||
      parseFloat(receivedQuantity) <= 0
    ) {
      formErrors.qty = "Qty should be more than zero";
    }

    if (
      parseFloat(poQuantity) <
        parseFloat(receivedQuantity) + parseFloat(totalreceivedQuantity) ||
      parseFloat(poValue) <
        parseFloat(receivedValue) + parseFloat(totalreceivedValue)
    ) {
      formErrors.qty = "Quantity or Value is more than PO Value";
      formErrors.val = "Quantity or Value is more than PO Value";
      setError("Quantity or Value is more than PO Value");
    }

    if (
      !receivedValue ||
      isNaN(parseFloat(receivedValue)) ||
      parseFloat(receivedValue) <= 0
    ) {
      formErrors.val = "Value should be more than zero";
    }

    if (parseFloat(receivedQuantity) > parseFloat(poQuantity)) {
      formErrors.qty = "Qty should not be more than PO Quantity";
    }

    if (parseFloat(receivedValue) > parseFloat(poValue)) {
      formErrors.val = "Value should be more than PO Value";
    }

    if (!getpass || getpass.length === 0) {
      formErrors.getpass = "Memo/Getpass Number Should not be Blank";
    }

    if (selectedOption === "1") {
      if (tpiagency.length === 0)
        formErrors.tpierr = "TPI Agency Should not be Blank";
    }

    if (selectedOption === "0") {
      // SelectionTypeValue = "0";
      settpiAgency(" ");
    }

    if (selectedOption.length === 0) {
      formErrors.selerr = "Inspection Type Not Selected";
    }

    if (itemselectedOption.length === 0) {
      formErrors.selitemerr = "Item Received Type Menu Not Selected";
    }

    setErrors(formErrors);

    // const keys = Object.keys(formErrors);
    //const values = keys.map((key) => formErrors[key]);
    // console.log(values);

    //console.log(itemselectedOption);
    //console.log (formErrors);
    if (Object.keys(formErrors).length === 0) {
      const podt = new Date(itemreceivedDate);
      const indentreceiptdt =
        podt.getFullYear() +
        "/" +
        parseInt(podt.getMonth() + 1) +
        "/" +
        podt.getDate();

      // const tpidt1 = new Date(tpiDate);
      // const tpidat =
      //   tpidt1.getFullYear() +
      //   "/" +
      //   parseInt(tpidt1.getMonth() + 1) +
      //   "/" +
      //   tpidt1.getDate();


      let tpidat = "";

      if (!showRemark) {
        const tpidt1 = new Date(tpiDate);
        tpidat = `${tpidt1.getFullYear()}/${tpidt1.getMonth() + 1}/${tpidt1.getDate()}`;
      }


      apiClient
        .post("/itemReceiptEntry", {
          vpoNumber: npoNumber,
          vitemReceivedDate: indentreceiptdt,
          vreceivedItemQty: receivedQuantity,
          vreceivedItemValue: receivedValue,
          vreason: reason,
          ventryUser: uname,
          vtpidate: tpidat,
          vtpiagency: tpiagency,
          vtpitype: selectedOption,
          vip: ip,
          vgetpassnumber: getpass,
          vitemreceivedtype: itemselectedOption,
        })
        .then(function (response) {
          setError(response.data);
          setgetpass("");
          settpiAgency("");
          setreason("");
          getdata();
          

          if (
            parseFloat(poQuantity) ===
            parseFloat(receivedQuantity) + parseFloat(totalreceivedQuantity)
          ) {

            // navigate("../itemreceivedlist", { replace: true });
          }


          if (selectedOption === "1") {
            navigate("../itemreceivedlist", { replace: true });
          }
          
        })
        .catch(function (error) {
          if (
            error.response.data &&
            error.response.data.code === "ER_DUP_ENTRY"
          ) {
            alert("Duplicate Gate Entry Pass Number for this PO Not Allowed");
            setButtonLoading(false);
          }
          
        });

    }
   
  };

  const getdata = async (e) => {


     if (!indentId || indentId.trim() === "") return;
    setButtonLoading(true);
   // alert(indentId);


    try {
      const response1 = await apiClient.post("/podetails", {
        uname: uname,
        indentNumber: String(indentId),
      });

      // Setting state with response data

      // setpomainReturnData(response1.data[0]);

      
            //console.log(pomainReturnData);


         //   console.log(response1.data.data[0]);
      setpoindentnumber(response1.data.data[0].indentnumber);
      setpoNumber(response1.data.data[0].ponumber);
      setpoDate(response1.data.data[0].podate);
      setConsigneeName(response1.data.data[0].consignee);
      setpoItemName(response1.data.data[0].poitem);
      setpoQuantity(response1.data.data[0].quantity);
      setpoValue(response1.data.data[0].value);
      setDPDate(response1.data.data[0].DPDate);
      // DPDate
      settotBalanceqty(response1.data.data[0].balanceQty_receivedItem);
      settotBalanceVal(response1.data.data[0].balanceVal_receivedItem);

      setreceivedQuantity(response1.data.data[0].quantity);
      setreceivedValue(response1.data.data[0].value);

      


if (response1.data.data[0].gemtype === 0) {
       const minValueDate = "'" + dayjs(response1.data.data[0].podate).format("YYYY-MM-DD") + "'";
        setMinCalDate(dayjs(minValueDate));




      }
else
{
const gemDate = "'" + dayjs(response1.data.data[0].gemdate).format("YYYY-MM-DD") + "'";
setMinCalDate(dayjs(gemDate));
setGeMNumber(response1.data.data[0].gemno);
setGemDate(dayjs(response1.data.data[0].gemdate).format("YYYY-MM-DD"))
}

   



    //  setMinCalDate(dayjs(minValueDate));

      getPOdata(response1.data.data[0].quantity, response1.data.data[0].value);
      setButtonLoading(false);
    } catch (error) {
      setError(error.response1 ? error.response1.data : error.message);
      setButtonLoading(false);
    }

  };

  


  const getPOdata = async (quantity = 0, value = 0) => {
    setButtonLoading(true);
    try {
      const response = await apiClient.post("/getReceivedItembyPONumber", {
        ponumber: indentId,
      });
      // console.log(response?.data);
      setPOReturnData(response.data);

      let totalIndentQty = 0;
      let totalIndentValue = 0;
      response?.data?.forEach((item) => {
        totalIndentQty += +item?.ItemQuantity;
        totalIndentValue += +item?.ItemValue;
      });

      setreceivedQuantity((quantity - totalIndentQty).toFixed(2));
      setreceivedValue((value - totalIndentValue).toFixed(2));

      settotalreceivedQuantity(totalIndentQty);
      settotalreceivedValue(totalIndentValue);
    } catch (err) {
      setError(err.response?.data || err.message);
    }
    setButtonLoading(false);
  };

  useEffect(() => {
    setButtonLoading(true);
    getdata();
    setButtonLoading(false);
  }, []);

  const headers = [
    //["Indent Number","",""],, ""
    ["Indent Number", "PO Number", "Item Name"],
    ["PO date", "PO Quantity", "PO Value"],
    ["DP date","GeM Number","Gem Date"],
    ["Consignee", "Receivable Quantity", "Receivable Value"],
  ];

  const rows = [
    [poindentnumber, npoNumber, poItemName],
    [poDate, poQuantity, poValue],
    [dpDate,GeMNumber,GemDate],
    [ConsigneeName, totBalanceqty, totBalanceVal],
  ];

  const itemreceivedmenuoptions = [
    { value: "0", label: "All Item Received" },
    { value: "1", label: "Partial Item Received" },
    { value: "2", label: "Final Item of Partial Received Items" },
  ];

  const inseptionmenuoptions = [
    { value: "0", label: "Consignee" },
    { value: "1", label: "Pre Inspected" },
  ];

  const columns = [
    "getpassnumber",
    "itemReceivedDate",
    "ItemQuantity",
    "ItemValue",
    "TPIDESC"
  ];

  const columnNames = [
    "Gate Entry/Challan/Invoice Number",
    "Received Date",
    "Quantity",
    "Value",
    "Inspection Type",
  ]; // keys from your data objects


  const poCancelConfirm = async () => {
    const isConfirmed = window.confirm(
      `Are you sure you want to Cancel PO Number: ${indentId}\n\nCaution : Duplicate PO cannot be created again.`
    );
      if (isConfirmed) {
        setShowcancleRemark(true);
            }

      else
      {
        setShowcancleRemark(false);
        setcancleRemark("");
      }
    };


    const poCancel = async () => {
      setPageLoader(true);
      const isConfirmed = window.confirm(
        `Are you sure to Cancel PO Number: ${indentId}\n\nCaution : Duplicate PO cannot be created again.`
      );
        if (isConfirmed) {
        
        try {
          const response = await apiClient.post("/pocancel", {
            vponumber: String(indentId),
            ventryUser: uname,
            vip: ip,
            vreason: cancleRemark,
            
          });
    
          navigate('../', { replace: true });
        } catch (error) {
        //alert(error);
        navigate('../', { replace: true });
        }
        }
  
        else
        {
          setShowcancleRemark(false);
          setcancleRemark("");
        }
        setPageLoader(false);
      };



  const getUnsutablePOdata = useCallback(async () => {
if (!indentId || indentId.trim() === "") return;
    try {
      const response = await apiClient.post("/getUnsutablePO_by_PONumber", {
        ponumber: String(indentId),
        gatepassnumber:'',
      });

     //  console.log(response.data[0].unsuitabilitytype);


        if (response.data[0].unsuitabilitytype === "Suitable") {
          setSuitabilityDone("Suitable")
        } 



        
      setunsuitablePOList(response.data);





    } catch (err) {}
  }, [String(indentId)]); // Include indentNo in the dependency array if getPOdata depends on it

  useEffect(() => {
    // Update state if roles change (in case roles are updated dynamically)
    getUnsutablePOdata();
  }, [String(indentId)]);

  

const columns1 = [
  "getpassnumber",
    "unsuitabilitytype",
    "SuitabilityDate",
    "reason",
    "receivedItemQty",

  ];

  const columnNames1 = [
    "Gate Entry/Challan/Invoice Number",
    "Insepction Result",
    "Date",
    "Reason",
    "Quantity",
    
  ]; // keys from your data objects


  const handleDateChange = (newDate, setDate) => {
    if (newDate) {
      setDate(newDate);
      setErrors({ ...errors, errDate: false }); // Clear error if a valid date is selected
    } else {
      setErrors({ ...errors, errDate: true }); // Show error if date is cleared
    }
  };

  

  return (
    <div >
      
      <Card className="Formcard">
      <div className="input-groupHeading">
      Received Item's Entry

            </div>

        <CardContent>
          {/* <div className="p-4">
            <ListHeaderTableComponent headers={headers} rows={rows} />
          </div> */}

<Accordion defaultExpanded>
        <AccordionSummary
          expandIcon={<ArrowDownwardIcon />}
          aria-controls="panel1-content"
          id="panel1-header"
        >
          <Typography component="span" variant="h6">PO Details</Typography>
        </AccordionSummary>
        <AccordionDetails>
        
            <ListHeaderTableComponent headers={headers} rows={rows} />
        
        </AccordionDetails>
      </Accordion>

          <div className="row mt-4">
            <div className="container">
              <div className="input-group mt-2">
                <CustomTextField
                  label="Gate Entry Pass Number/ Memo Number/ Invoice Number"
                  value={getpass ?? ""}
                  onChange={(e) => {
                    setgetpass(e.target.value);
                  }}
                  placeholder="Enter Entry Pass Number/ Memo Number/ Invoice Number"
                  maxLength={50} // Set the maximum length
                  error={!!errors.getpass}
                  helperText={errors.getpass}
                />
              </div>

              <div className="input-group">
                <DatePickerComponent
                  label="Item Receiving Date"
                  id="receiveddate"
                  value={itemreceivedDate}
                  onChange={(newDate) =>
                    handleDateChange(newDate, setitemreceivedDate)
                  } 
                error={errors.errDate}
                  maxDate={maxDate} //{dpDate ? dayjs.min(today, dpDate) : today}
                  minDate={minCalDate}
                />
              </div>
            </div>

            <div className="container">
              <div className="input-group">
                <NumericTextField
                  id="receivedItemQuantity"
                  label="Received Item Quantity"
                  title="Received Item Quantity"
                  error={errors.qty}
                  value={receivedQuantity ?? "0"}
                  onChange={handleQuantityChange}
                />
              </div>
              <div className="input-group">
                <NumericTextField
                  id="receivedItemValue"
                  label="Received Item Value"
                  title="Received Item Value"
                  error={errors.val}
                  value={receivedValue ?? "0"}
                  onChange={handleValueChange}
                />
              </div>
            </div>

            <div className="container">
              <div className="input-group">
                <CustomDropdownMenu
                  options={itemreceivedmenuoptions}
                  selectedOption={itemselectedOption}
                  handleOptionChange={handleOptionitemChange}
                  error={errors.selitemerr}
                  menulabel="Select Item Received Option"
                />
              </div>
              <div className="input-group">
                <CustomDropdownMenu
                  options={inseptionmenuoptions}
                  selectedOption={selectedOption}
                  handleOptionChange={handleOptionChange}
                  error={errors.selerr}
                  menulabel="Select Pre Inspection Option"
                />
              </div>
            </div>

            {!showRemark && (
              <>
                <div className="container">
                  <div className="input-group">
                    <DatePickerComponent
                      label="TPI Date"
                      id="tpidate"
                      value={tpiDate}
                      
                      onChange={(newDate) =>
                        handleDateChange(newDate, setTpiDate)
                      } 
		      
                      error={errors.errtpiDate}
                      
                      maxDate={
                        itemreceivedDate ? dayjs(itemreceivedDate) : dayjs()
                      }
                      // maxDate={today}
                      minDate={minCalDate}
                    />
                  </div>
                  <div className="input-group">
                    <CustomTextField
                      label="TPI Agency"
                      value={tpiagency ?? ""}
                      onChange={(e) => {
                        settpiAgency(e.target.value);
                      }}
                      placeholder="TPI Agency"
                      maxLength={50} // Set the maximum length
                      error={!!errors.tpierr}
                      helperText={errors.tpierr}
                    />
                  </div>
                </div>
              </>
            )}

            <div className="container">
              <CustomTextField
                label="Remark if Any ---> it should be not blank if Quantity or Value is not as per PO Value"
                value={reason ?? ""}
                onChange={(e) => {
                  setreason(e.target.value);
                }}
                placeholder="Reason"
                maxLength={50} // Set the maximum length
                error={!!errors.err}
                helperText={errors.err}
              />
            </div>
          </div>

          {/* ============================================LIST of ALL PO ===========================================*/}

          {POReturnData.length > 0 && (
            <TablewithSumFooter
              columns={columns}
              columnNames={columnNames}
              data={POReturnData}
              showProceedButton={true}
              buttonName="Item Proceed"
              rowNameKey="suitabilitystatus"
              valueKey={0}   //13-06-2025 change 0 to 1
              onButtonClick={handleButtonClick}
            />
          )}

          {/*=========================== END OF LIST ==========================================================*/}


 {/* ============================================LIST of UNSUITABLE PO  Details===========================================*/}

 {unsuitablePOList.length > 0 && (
  <>
    <div className="container" > <b>List of suitable/unsuitable done by Inspection Section</b></div>
    <TablewithSumFooter
      columns={columns1}
      columnNames={columnNames1}
      data={unsuitablePOList}
    />
  </>
)}


  {/*=========================== END OF UNSUITABLE PO  Details ==========================================================*/}



          <>
            <div className="container mt-4"></div>

            <div
              className="flex container"
              style={{
                display: "flex",
                paddingLeft: "40px",
                paddingRight: "40px",
                justifyContent: "space-between", // Distributes space between items
              }}
            >
              <button
                className="button button1"
                type="button" // Updated type attribute to "button"
                onClick={InsertPOData}
                title="Click for Data Save"
                disabled={buttonLoading}
              >
                
                Save Data
              </button>


            {suitabilityDone !== "Suitable" &&  (<button
                className="button button1"
                type="button" // Updated type attribute to "button"
                onClick={poCancelConfirm}
                title="Click for Cancel PO"
                //disabled={suitabilityDone !== "Suitable"}
                style={{ backgroundColor: "red", color: "white" }}
              >
                PO Cancel / Drop  
              </button>)
}

              <button
                className="button button1"
                type="button" // Updated type attribute to "button"
                onClick={handleClose}
                title="Click for Data Save"
                style={{ backgroundColor: "blue", color: "white" }}
              >
                Back to List
              </button>
            </div>
          </>



{showcancleRemark && (
  <>
 <div className="container" style={{ marginTop: 60 }}>
 
  <div className="input-group">
 <CustomTextField
   label="Remark --> it should be not blank"
   value={cancleRemark ?? ""}
   onChange={(e) => {
     setcancleRemark(e.target.value);
   }}
   placeholder="Cancellation Reason"
   maxLength={50} // Set the maximum length
   error={!!errors.err}
   helperText={errors.err}
 />
 <div className="input-group" style={{ display: 'flex', justifyContent: 'flex-end' }}>
  {pageLoader ? (
    <div className="loaderContainer">
      <CircularProgress />
    </div>
  ) : (
    <button
      className="button button1"
      type="button"
      onClick={poCancel}
      title="Click for Cancel PO"
      style={{ backgroundColor: "black", color: "white" }}
    >
      Click here: Finally Submit Cancellation
    </button>
  )}
</div>

 </div>
 
</div>

</>
)

};


         
        </CardContent>
      </Card>
    </div>
  );
}

export default ItemReceivedEntry;
